import { Link, Outlet, useLocation } from "react-router-dom";
export const Settings = () => {
  const location = useLocation();
  const pathName = location.pathname;
  const navItems = [
    { label: "Masters", pathname: "/settings/masters" },
    { label: "Preference", pathname: "/settings/preference" },
    { label: "Role Management", pathname: "/settings/roleManagement" },
    { label: "Integration", pathname: "/settings/integration" },
    { label: "Manage User", pathname: "/settings/users" },
  ];
  return (
    <div className="row d-flex" style={{ height: "90vh", overflow: "hidden" }}>
      <div
        className="col-md-2 pt-3"
        style={{
          height: "100vh",
          position: "sticky",
          top: 0,
          borderRight: "1px solid #dedede",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* Sidebar Header */}
        <div className="d-flex flex-column text-start mt-0" style={{ lineHeight: "0.85rem" }}>
          <h6 style={{ fontWeight: "500", color: "black", fontSize: "1.0rem" }}>
            Settings & Config.
          </h6>
          <p className="text-muted mb-1 small" style={{ textWrap: "nowrap", color: "#c7c7c7 !important" }}>
            Internal configurations here!
          </p>
          <hr className="mt-2 mb-4" style={{ borderTop: "0.5px solid #6c757d", opacity: "0.3" }} />
        </div>
        <ul className="p-0 mb-0" style={{ listStyle: "none" }}>
          {navItems.map((item) => (
            <li key={item.pathname} className="mb-2 rounded">
              <Link
                to={item.pathname}
                className={`d-block px-3 py-2 rounded text-decoration-none sidebar-link ${
                  pathName === item.pathname ? "bg-brown text-white" : "bg-color text-dark"
                }`}
              >
                {item.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      {/* Main Content Area */}
      <div
        className="p-1 col-md-10"
        style={{
          borderLeft: "1px solid #dedede",
          height: "100vh",
          // overflowY: "auto",
          // overflowX: "hidden",
        }}
      >
        <div className="p-3 mb-5">
          <Outlet  />
        </div>
      </div>

      <style>
        {`
          .bg-color{
            background-color:rgb(237 237 237 / 95%) !important;
          }
          .bg-brown {
            background-color: #7a3a5e;
          }
          .sidebar-link {
            transition: background-color 0.3s ease, color 0.3s ease;
          }
          .sidebar-link:hover {
            background-color: #7a3a5e !important;
            color: white !important;
          }
        `}
      </style>
    </div>
  );
};